module.exports = __webpack_public_path__ + "img/team2.87df62bb.png";